import { Actions } from "../components/Store/Reducer";

export const login = async ({
  userId,
  password,
  setIsLoading,
  setError,
  store,
}) => {
  if (setError) setError(null);
  if (setIsLoading) setIsLoading(true);

  const apiPath = "/auth/login";
  const body = JSON.stringify({
    uId: userId,
    pwd: password,
    erpId: store.vars.Meta.Erp,
  });
  try {
    const API_BASE = `https://${store.vars.SCStation.Hostname}:${store.vars.SCStation.Port}`;
    const response = await fetch(`${API_BASE}${apiPath}`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: body,
    });
    const result = await response.json();
    if (setIsLoading) setIsLoading(false);
    return result;
  } catch (error) {
    if (setError) setError(error.message);
    if (setIsLoading) setIsLoading(false);
  }
};

const scStationGET = async ({
  apiPath,
  params,
  form,
  store: { vars },
  dispatch,
  intl,
  setIsLoading,
  setError,
  emptyReturn,
}) => {
  if (setError) setError(null);
  if (setIsLoading) setIsLoading(true);
  let result;
  const API_BASE = `https://${vars.SCStation.Hostname}:${vars.SCStation.Port}`;

  const paramsUri = params === undefined ? "" : `?${params}`;
  const jwt = sessionStorage.getItem("token");
  const response = await fetch(`${API_BASE}${apiPath}${paramsUri}`, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
  });
  try {
    const json = await response.json();
    if (json.code !== 0) throw new Error(json.msg);
    result = json.data;
    if (setIsLoading) setIsLoading(false);
    return result ? result : emptyReturn;
  } catch (error) {
    if (response.status === 401)
      dispatch({ type: Actions.Logout, payload: null });
    if (setError) setError(error.message);
    if (setIsLoading) setIsLoading(false);
  }
};

const scStationPOST = async ({
  apiPath,
  params,
  form,
  store: { vars },
  httpMethod = "POST",
  dispatch,
  setIsLoading,
  setError,
}) => {
  if (setError) setError(null);
  if (setIsLoading) setIsLoading(true);
  let result;
  // format parameters
  const postParams = new URLSearchParams();
  if (form !== undefined && form) {
    for (const [key, value] of Object.entries(form)) {
      postParams.append(key, value);
    }
  }

  const contentType = form
    ? "application/json"
    : "application/x-www-form-urlencoded; charset=UTF-8";
  const API_BASE = `https://${vars.SCStation.Hostname}:${vars.SCStation.Port}`;
  const paramsUri = params === undefined ? "" : `?${params}`;
  const jwt = sessionStorage.getItem("token");
  const response = await fetch(`${API_BASE}${apiPath}${paramsUri}`, {
    method: httpMethod,
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": `${contentType}`,
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: form ? form : postParams,
  });
  try {
    const json = await response.json();
    if (json.code !== 0) throw new Error(json.code);
    result = json.data;
    if (setIsLoading) setIsLoading(false);
    return result ? result : true;
  } catch (error) {
    if (response.status === 401)
      dispatch({ type: Actions.Logout, payload: null });
    if (setError) setError(error.message);
    if (setIsLoading) setIsLoading(false);
  }
};

// Care Unit API ==================================================================================
// List care units
export const listStations = async ({
  username,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = `/careunits/account/${username}`;
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Account API ====================================================================================
// Create user account
export const createAccount = async ({
  userName,
  userId,
  password,
  status,
  role,
  careUnits,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = "/accounts";
  const form = JSON.stringify({
    erpId: store.vars.Meta.Erp,
    uName: userName,
    uId: userId,
    pwd: password,
    status: status,
    role: role,
    careUnitIds: careUnits,
  });
  return await scStationPOST({
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

export const listAccounts = async ({
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = "/accounts";
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  }).then((data) => {
    if (data) dispatch({ type: Actions.SetAccounts, payload: data });
  });
};

export const editAccount = async ({
  userName,
  userId,
  password,
  status,
  role,
  careUnits,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const httpMethod = "PATCH";
  const apiPath = `/accounts/${userId}`;
  const form = JSON.stringify({
    erpId: store.vars.Meta.Erp,
    uName: userName,
    uId: userId,
    pwd: password,
    status: status,
    role: role,
    careUnitIds: careUnits,
  });
  return await scStationPOST({
    httpMethod,
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

export const updatePassword = async ({
  userId,
  newPwd,
  oldPwd,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const httpMethod = "PATCH";
  const apiPath = `/accounts/pwd/${userId}`;
  const form = JSON.stringify({
    uId: userId,
    newPwd: newPwd,
    oldPwd: oldPwd,
  });
  return await scStationPOST({
    httpMethod,
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

export const forceUpdatePassword = async ({
  userId,
  password,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const httpMethod = "PATCH";
  const apiPath = `/accounts/pwdr/${userId}`;
  const form = JSON.stringify({
    uId: userId,
    pwd: password,
  });
  return await scStationPOST({
    httpMethod,
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// BOX API =====================================================================================
// find boxes by care unit id
export const findBoxesByCareUnitId = async ({
  station,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = station
    ? `/boxes/careunit/${station.careUnitId}`
    : `/boxes/careunit/${store.scStation.careUnitId}`;
  const emptyReturn = [];
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
    emptyReturn,
  });
};

// Update Box Pairing
export const boxUpdateBedNo = async ({
  bedNo,
  boxId,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const httpMethod = "PATCH";
  const apiPath = `/boxes/bed/${boxId}`;
  const form = JSON.stringify({
    bedNo: bedNo,
  });
  return await scStationPOST({
    httpMethod,
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Clear Box Pairing
export const boxRemove = async ({
  boxId,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const params = `boxId=${boxId}&loginUserId=${store.loginUserId}`;
  const apiPath = "/sc/api/box/remove.do";
  return await scStationPOST({
    apiPath,
    params,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Patient API ==================================================================================
// Find Patient
export const patientFindPatientByPatientSn = async ({
  patientSn,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = `/patients/${patientSn}`;
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Patient Checkin
export const patientCheckin = async ({
  boxSettings,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const form = JSON.stringify(boxSettings);
  const apiPath = "/patients/chkin";
  return await scStationPOST({
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Patient Transfer
export const patientTransfer = async ({
  boxSettings,
  setError,
  store,
  dispatch,
  intl,
}) => {
  const apiPath = "/patients/transition";
  const form = JSON.stringify(boxSettings);
  return await scStationPOST({
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setError,
  });
};

// Patient Checkout
export const patientCheckout = async ({
  patientSn,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const form = JSON.stringify({ patientSn: patientSn });
  const apiPath = "/patients/chkout";
  return await scStationPOST({
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Find box settings by station id
export const findBoxSettingsBySCStationId = async ({
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = `/boxsettings/careunit/${store.scStation.careUnitId}`;
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Get default settings by station id
export const getDefaultSettingsBySCStationId = async ({
  careUnitId,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = `/boxsettings/default/settingtype/chkIn/careUnit/${careUnitId}`;
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Find Box Settings
export const findBoxSettingByBoxId = async ({
  boxId,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const form = {
    boxId: boxId,
  };
  const apiPath = "/sc/api/box/findBoxSettingByBoxId.do";
  return await scStationPOST({
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Find Boxes not assigned to a care unit
export const findBoxesWithoutCareUnit = async ({
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = "/sc/api/box/findBoxsNonCareUnit.do";
  return await scStationPOST({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

// Assign a box to a care unit
export const assignBoxToCareUnit = async ({
  boxId,
  careUnitId,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const params = `boxId=${boxId}&careUnitId=${careUnitId}&loginUserId=${store.loginUserId}`;
  const apiPath = "/sc/api/box/updateCareUnitByBoxId.do";
  return await scStationPOST({
    apiPath,
    params,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

export const updateBoxSettings = async ({
  boxId,
  boxSettings,
  setError,
  store,
  dispatch,
  intl,
}) => {
  const httpMethod = "PATCH";
  const apiPath = `/boxsettings/${boxId}`;
  const form = JSON.stringify(boxSettings);
  return await scStationPOST({
    httpMethod,
    apiPath,
    form,
    store,
    dispatch,
    intl,
    setError,
  });
};

// Find checked in Patient by Patient Id
export const findPatientByPatientId = async ({
  patientId,
  store,
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const apiPath = `/patients/id/${patientId}`;
  return await scStationGET({
    apiPath,
    store,
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

export const findBoxEvents = async ({
  patientSn,
  createDateStart,
  createDateEnd,
  store: { vars, user },
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const form = { patientSn, createDateStart, createDateEnd };
  const apiPath = "/sc/api/box/findBoxEvents.do";
  return await scStationPOST({
    apiPath,
    form,
    store: { vars, user },
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};

export const findBoxSettingsByPatientSnAndCreationDate = async ({
  patientSn,
  creationDate,
  store: { vars, user },
  dispatch,
  intl,
  setIsLoading,
  setError,
}) => {
  const form = { patientSn, creationDate };
  const apiPath = "/sc/api/box/findBoxSettingsByPatientSnAndCreationDate.do";
  return await scStationPOST({
    apiPath,
    form,
    store: { vars, user },
    dispatch,
    intl,
    setIsLoading,
    setError,
  });
};
